<template>
  <b-row>
    <b-col cols="12" md="8">
      <b-form-input
        v-model="activationCode"
        :class="{
          'is-valid': isValid,
          'is-invalid': isInvalid,
        }"
      />
    </b-col>
    <b-col cols="12" md="4" class="mt-3 mt-md-0">
      <b-button-toolbar>
        <div>
          <b-button-group>
            <b-button variant="primary" @click="applyCode">
              Apply
            </b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button variant="outline-secondary" @click="clearCode">
              Clear
            </b-button>
          </b-button-group>
        </div>
      </b-button-toolbar>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "ActivationCodeInput",
  data() {
    return {
      activationCode: "",
      isValid: false,
      isInvalid: false,
    };
  },
  methods: {
    applyCode() {
      this.$emit("apply-code", this.activationCode);
    },
    clearCode() {
      this.activationCode = "";
      this.isValid = false;
      this.isInvalid = false;
      this.$emit("clear-code");
    },
    reset() {
      this.activationCode = "";
      this.isValid = false;
      this.isInvalid = false;
    },
    setValid() {
      this.isValid = true;
      this.isInvalid = false;
    },
    setInvalid() {
      this.isValid = false;
      this.isInvalid = true;
    },
  },
};
</script>
<style scoped>
.is-valid {
  border-color: #28a745;
  background-color: #f8fff9;
}
.is-invalid {
  border-color: #dc3545;
  background-color: #fff8f8;
}

[data-theme="dark"] .is-valid {
  border-color: #4ade80;
  background-color: rgba(74, 222, 128, 0.1);
}
[data-theme="dark"] .is-invalid {
  border-color: #f87171;
  background-color: rgba(248, 113, 113, 0.1);
}
</style>